export const benefit = {
  'And a good friendship is where is get double the discount! Your friends <1>also have a discount of {{discount}}</1> to get their hair removal up to date!':
    'E amizade boa mesmo é quando tem desconto em dobro! Os seus amigos <1>também ganham {{discount}}</1> de desconto para garantirem a depilação em dia!',
  'Could not recommend the following people {{customers}}':
    'Não foi possível indicar as seguintes pessoas: {{customers}}',
  'Loading data': 'Carregando dados...',
  Name: 'Nome',
  'Name of the recommended person': 'Nome da pessoa indicada',
  'Please, inform a fullname': 'Por favor, informe um nome completo',
  'Please, inform a valid number': 'Por favor, informe um número válido',
  PHONE_PLACEHOLDER: '(00) 00000-0000',
  Recommend: 'Indicar',
  Recommendation: 'Indicação',
  'Recommendations successfully made!': 'Indicações feitas com sucesso!',
  'The discount is valid only on purchases of packages worth more than <1>{{value}}</1>':
    'Desconto válido para compras de pacotes com valores acima de <1>{{value}}</1>',
};
